import React from 'react';

import Modal from "../../../component/modal/ModalTemplate";
import { PRIMARY_BTN, SECONDARY_BTN, FOOTER_CENTER } from "./modalStyle";

interface Coupon {
    name: string;
    amount: string | number;
}

interface CouponListModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    coupons: Coupon[];
}

const CouponListModal: React.FC<CouponListModalProps> = ({ isOpen, onRequestClose, coupons }) => {
    return (
        <Modal
            open={isOpen}
            handleClose={onRequestClose}
            modalTitle="내 쿠폰 정보"
            className="react-modal"
        >
            <div className="modal-body tw-max-h-[500px] tw-overflow-y-auto">
                {coupons.length === 0 && <h4 className="tw-text-base tw-font-semibold tw-text-[#495057]">현재 보유하신 쿠폰이 없습니다.</h4>}
                {coupons.map((item, index) => (
                    <div
                        key={index}
                        className="tw-mx-auto tw-mb-3 tw-w-3/4 tw-rounded tw-border tw-border-t-4 tw-border-[#e9ecef] tw-border-t-[#5D87FF] tw-bg-[#F6F9FC] tw-p-3 tw-py-5 tw-text-center"
                    >
                        <h4 className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-lg tw-font-semibold tw-text-[#5D87FF]">
                            <span className="material-symbols-rounded">grade</span>
                            <span>{item.name}</span>
                            <span className="material-symbols-rounded">grade</span>
                        </h4>
                        <p className="tw-m-0 tw-text-[#272B2F]">{item.amount}</p>
                    </div>
                ))}
            </div>
            <div className={FOOTER_CENTER}>
                <button type="button" className={PRIMARY_BTN} onClick={onRequestClose}>확인</button>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>취소</button>
            </div>
        </Modal>
    );
};

export default CouponListModal;
